module.exports = __webpack_public_path__ + "img/home1.8fd98a4c.png";